module.exports = __webpack_public_path__ + "static/media/logo.2e0b8000.svg";